import type { SiteContent } from '../types'

/**
 * Single source of content truth.
 * Bolton, Victor, and Dad: edit this file to add memories, kid quotes, and photos.
 * Every photo must have alt text. Keep it kind, keep it true, keep first names only.
 */
export const content: SiteContent = {
  hero: {
    title: 'Thank You, Irina',
    subtitle: 'For the hot dogs, the beach, Topgolf, the laughs, and the memories.',
    ctaLabel: 'Start the Weekend',
  },

  chapters: {
    hotdogs: {
      id: 'hotdogs',
      title: 'The Hot-Dog Party',
      blurb: 'Homemade chili. A disco ball. The American way, the first time.',
      emoji: '🌭',
    },
    beach: {
      id: 'beach',
      title: 'Kite Beach',
      blurb: 'A long walk, bikes, scooters, badminton, rocks in the water, burgers.',
      emoji: '🌊',
    },
    topgolf: {
      id: 'topgolf',
      title: 'Topgolf Sunday',
      blurb: 'Aiming for targets, hitting balls, finishing the weekend strong.',
      emoji: '⛳',
    },
  },

  cards: [
    {
      id: 'hd-disco',
      chapter: 'hotdogs',
      title: 'Disco-ball energy',
      blurb: 'Music on, lights spinning, everyone laughing.',
      caption: 'You brought the disco ball.',
      effect: 'sparkle',
    },
    {
      id: 'hd-firsttime',
      chapter: 'hotdogs',
      title: 'Your first hot dogs',
      blurb: 'Researched the toppings. Made the chili from scratch. Did it the American way.',
      caption: 'One of Dad’s best hot dogs ever.',
      effect: 'topping',
      photo: {
        src: '/photos/hotdog-1600.webp',
        alt: 'The hot-dog spread you made',
        crop: 'landscape',
      },
    },
    {
      id: 'beach-bikes',
      chapter: 'beach',
      title: 'Bikes and scooters',
      blurb: 'Boardwalk on wheels, all the way down Kite Beach.',
      caption: 'Got the bike rentals sorted.',
      effect: 'flag',
      photo: {
        src: '/photos/irina-beach-800.webp',
        alt: 'You and the kids at Kite Beach',
        crop: 'landscape',
      },
    },
    {
      id: 'beach-badminton',
      chapter: 'beach',
      title: 'Beach badminton',
      blurb: 'Surprisingly intense. Surprisingly fun.',
      effect: 'wave',
    },
    {
      id: 'beach-rocks',
      chapter: 'beach',
      title: 'Rocks in the water',
      blurb: 'Throw, splash, find a better one, throw again.',
      effect: 'splash',
      video: {
        src: '/media/irina-vic-bolton-rocks.mp4',
        poster: '/media/irina-vic-bolton-rocks-poster.jpg',
        alt: 'Throwing rocks into the water at Kite Beach',
        crop: 'landscape',
      },
    },
    {
      id: 'beach-burgers',
      chapter: 'beach',
      title: 'Burgers by the sand',
      blurb: 'Earned them.',
      effect: 'flag',
    },
    {
      id: 'tg-targets',
      chapter: 'topgolf',
      title: 'Aim for the targets',
      blurb: 'Each ring lit up green when you nailed it.',
      effect: 'sparkle',
      photo: {
        src: '/photos/bolton-top-golf-800.webp',
        alt: 'Bolton lining up a Topgolf shot',
        crop: 'portrait',
      },
    },
    {
      id: 'tg-finish',
      chapter: 'topgolf',
      title: 'Sunday well-spent',
      blurb: 'A great way to close the weekend together.',
      effect: 'bloom',
    },
  ],

  kids: [
    {
      kid: 'Victor',
      favoriteMoment: '[VICTOR — write your favorite moment from the weekend here.]',
      thankYou: '[VICTOR — write your thank-you message to Irina here.]',
      ideaTags: ['hotdog', 'sparkles'],
    },
    {
      kid: 'Bolton',
      favoriteMoment: '[BOLTON — write your favorite moment from the weekend here.]',
      thankYou: '[BOLTON — write your thank-you message to Irina here.]',
      ideaTags: ['waves', 'golf'],
    },
  ],

  bouquet: [
    { id: 'plan-beach', label: 'beach day', petalColor: '#dc2626' },
    { id: 'pay-burgers', label: 'the burgers', petalColor: '#b91c1c' },
    { id: 'rent-bikes', label: 'bike rentals', petalColor: '#ef4444' },
    { id: 'cook-hotdogs', label: 'hot dogs', petalColor: '#dc2626' },
    { id: 'cook-chili', label: 'the chili', petalColor: '#991b1b' },
    { id: 'bring-music', label: 'disco ball', petalColor: '#e11d48' },
    { id: 'topgolf', label: 'Topgolf', petalColor: '#b91c1c' },
    { id: 'love', label: 'feeling loved', petalColor: '#dc2626' },
    { id: 'special', label: 'the weekend', petalColor: '#7f1d1d' },
  ],

  toppings: [
    { id: 'chili', label: 'Chili', emoji: '🌶️', color: '#b91c1c' },
    { id: 'cheese', label: 'Cheese', emoji: '🧀', color: '#facc15' },
    { id: 'pickles', label: 'Pickles', emoji: '🥒', color: '#65a30d' },
    { id: 'relish', label: 'Relish', emoji: '🥬', color: '#84cc16' },
    { id: 'sauerkraut', label: 'Sauerkraut', emoji: '🥬', color: '#a3a300' },
    { id: 'onions', label: 'Fried onions', emoji: '🧅', color: '#d97706' },
  ],

  closing: {
    line: 'Thank you, Irina, for making this weekend special.',
    signoff: 'From Bolton and Victor',
  },
}
